import React from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => {
  const faqs = [
    {
      question: "What is the Frequency of Magazine",
      answer: "YoungPresso is a Weekly Magazine with Latest NEWS of the week. Get it every Saturday morning by 11 a.m."
    },
    {
      question: "How is the Magazine delivered?",
      answer: "Latest Magazine issue is uploaded on our NEWS Platform every Saturday morning. You will notified and reminded on WhatsApp."
    },
    {
      question: "What topics are covered in the magazine?",
      answer: "Each issue includes Current Affairs in Kid-friendly language, Latest India NEWS, Sports News, International News, Knowledge Bites (Word of the Week, Did You Know, Riddles), and fascinating topics like Space, Science, and more!"
    },
    {
      question: "How can my Child Read the Magazine?",
      answer: "Upon Subscription, you will get details about YoungPresso NEWS Platform, which can be accessed on any Browser from Mobile, Laptop, or Tablet."
    },
    {
      question: "I am worried about Screentime",
      answer: "It is hardly 30-40 minutes screentime/week, as the Magazine is super-engaging, picture-based and simple text. Trust us, you will actually feel good after giving this Screentime"
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer: "Absolutely! We have a hassle-free CANCEL-ANYTIME policy. Just send an email to info@youngpresso.com and we'll process your cancellation immediately. No questions asked."
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
      <Typography
        variant="h3"
        align="center"
        sx={{
          mb: 2,
          fontWeight: 900,
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
          background: 'linear-gradient(45deg, #FF6B35 30%, #06AED5 70%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}
      >
        Frequently Asked Questions
      </Typography>

      <Typography 
        variant="h6" 
        align="center" 
        sx={{ 
          color: 'rgba(255,255,255,0.8)', 
          mb: 6, 
          fontSize: '1.1rem' 
        }}
      >
        Got questions? We've got answers!
      </Typography>

      <Box sx={{ maxWidth: '900px', margin: '0 auto' }}>
        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            sx={{
              background: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(10px)',
              borderRadius: '12px !important',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              mb: 2,
              '&:before': {
                display: 'none',
              },
              '&.Mui-expanded': {
                margin: '0 0 16px 0',
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 107, 53, 0.3)',
              }
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon 
                  sx={{ 
                    color: '#FF6B35',
                    fontSize: '2rem'
                  }} 
                />
              }
              sx={{
                '& .MuiAccordionSummary-content': {
                  margin: '16px 0',
                },
                '&:hover': {
                  background: 'rgba(255, 107, 53, 0.05)',
                }
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  fontWeight: 700,
                  color: 'rgba(255, 255, 255, 0.95)',
                  pr: 2
                }}
              >
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                pt: 0,
                pb: 3,
                px: 3
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                  color: 'rgba(255, 255, 255, 0.8)',
                  lineHeight: 1.7
                }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      {/* Still have questions? Contact section */}
      <Box 
        sx={{ 
          mt: 6, 
          textAlign: 'center',
          p: 4,
          background: 'rgba(6, 174, 213, 0.1)',
          borderRadius: '16px',
          border: '1px solid rgba(6, 174, 213, 0.3)',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '1.1rem', sm: '1.3rem' },
            fontWeight: 700,
            color: 'rgba(255, 255, 255, 0.95)',
            mb: 2
          }}
        >
          Still have questions?
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '0.95rem', sm: '1rem' },
            color: 'rgba(255, 255, 255, 0.8)',
            mb: 3
          }}
        >
          We're here to help! Reach out to us anytime.
        </Typography>
        <Button
          variant="contained"
          href="mailto:info@youngpresso.com"
          sx={{
            background: 'linear-gradient(45deg, #06AED5 30%, #4FC3F7 70%)',
            color: 'white',
            fontWeight: 'bold',
            py: 1.5,
            px: 4,
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: '0 4px 20px rgba(6, 174, 213, 0.4)',
            '&:hover': {
              background: 'linear-gradient(45deg, #0596B8 30%, #3BAED0 70%)',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 25px rgba(6, 174, 213, 0.5)'
            }
          }}
        >
          Contact Us
        </Button>
      </Box>
    </Container>
  );
};

export default FAQ;
